import { render, staticRenderFns } from "./VueHazardmapMessageComponent.vue?vue&type=template&id=2db48b48&lang=pug&"
import script from "./VueHazardmapMessageComponent.vue?vue&type=script&lang=js&"
export * from "./VueHazardmapMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/k-aso/works/city.yokote.lg.jp/yokote-hazard.com/city.yokote.lg.jp_yokote-hazard.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db48b48')) {
      api.createRecord('2db48b48', component.options)
    } else {
      api.reload('2db48b48', component.options)
    }
    module.hot.accept("./VueHazardmapMessageComponent.vue?vue&type=template&id=2db48b48&lang=pug&", function () {
      api.rerender('2db48b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/VueHazardmapMessageComponent.vue"
export default component.exports